import { render, staticRenderFns } from "./card_2.vue?vue&type=template&id=25b6389f&scoped=true"
import script from "./card_2.vue?vue&type=script&lang=js"
export * from "./card_2.vue?vue&type=script&lang=js"
import style0 from "./card_2.vue?vue&type=style&index=0&id=25b6389f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b6389f",
  null
  
)

export default component.exports